import * as DashboardConstants from '../Dashboards/DashboardConstants';

export const queueStatusHeaders = [
    {
        key: 'automataName',
        header: DashboardConstants.AutomataName,
        hidden: false,
        optional: false
    },
    {
        key: 'queueName',
        header: DashboardConstants.QueueName,
        hidden: false,
        optional: false
    },
    {
        key: 'totalItem',
        header: DashboardConstants.TotalItem,
        hidden: false,
        optional: false
    },
    {
        key: 'pending',
        header: DashboardConstants.Pending,
        hidden: false,
        optional: false
    },
    {
        key: 'running',
        header: DashboardConstants.Running,
        hidden: false,
        optional: false
    },
    {
        key: 'completed',
        header: DashboardConstants.Completed,
        hidden: false,
        optional: false
    },
    {
        key: 'businessException',
        header: DashboardConstants.BusinessEx,
        hidden: false,
        optional: false
    },
    {
        key: 'systemExecption',
        header: DashboardConstants.SystemEx,
        hidden: false,
        optional: false
    },
    {
        key: 'deferred',
        header: DashboardConstants.Deferred,
        hidden: false,
        optional: false
    },
    {
        key: 'recentTimeProcessedAt',
        header: DashboardConstants.RecentItemProcessedAt,
        hidden: false,
        optional: false
    },
    {
        key: 'timeSpanLastProcesses',
        header: DashboardConstants.TimespanSinceLastItemProcessed,
        hidden: false,
        optional: false
    }
];


export const queueStatusExpandedHeaders = [
    {
        key: 'automataName',
        header: DashboardConstants.ResourceName,
        hidden: false,
        optional: false
    },
    {
        key: 'status',
        header: DashboardConstants.Status,
        hidden: false,
        optional: false
    },
    {
        key: 'queueName',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'totalItem',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'pending',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'running',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'completed',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'businessException',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'systemExecption',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'recentTimeProcessedAt',
        header: "",
        hidden: false,
        optional: false
    },
    {
        key: 'timeSpanLastProcesses',
        header: "",
        hidden: false,
        optional: false
    }
];


export const queueStatusMockData = [
    {
        "automataName": "Missing Labour Claim Process",
        "queueName": "PR Queue",
        "totalItem": 1050,
        "pending": 513,
        "running": 5,
        "completed": 453,
        "businessException": 17,
        "systemExecption": 83,
        "recentTimeProcessedAt": "1/12/2022 8:31:31 AM",
        "resources": [
            {
                "name": "Lenovo001",
                "status": "busy",
                "queueName": "PR Queue",
                "totalItem": 1050,
                "pending": 513,
                "running": 5,
                "completed": 453,
                "businessException": 17,
                "systemExecption": 83,
                "recentTimeProcessedAt": "1/12/2022 8:31:31 AM",
                "incidentId": null,
                "incidentUrl": null,
                dotValue: 100,
            },
            {
                "name": "Lenovo002",
                "status": "offline",
                "queueName": "PR Queue",
                "totalItem": 1050,
                "pending": 513,
                "running": 5,
                "completed": 453,
                "businessException": 17,
                "systemExecption": 83,
                "recentTimeProcessedAt": "1/12/2022 8:31:31 AM",
                "incidentId": null,
                "incidentUrl": null,
                dotValue: 25
            }
        ]
    },
    {
        "automataName": "UC-17_DailyCheckActivity_P3",
        "queueName": "PR Queue",
        "totalItem": 1050,
        "pending": 513,
        "running": 5,
        "completed": 453,
        "businessException": 17,
        "systemExecption": 83,
        "recentTimeProcessedAt": "1/12/2022 8:31:31 AM",
        "resources": [
            {
                "name": "Lenovo001",
                "status": "Missing",
                "queueName": "PR Queue",
                "totalItem": 1050,
                "pending": 513,
                "running": 5,
                "completed": 453,
                "businessException": 17,
                "systemExecption": 83,
                "recentTimeProcessedAt": "1/12/2022 8:31:31 AM",
                "incidentId": "INC1869814",
                "incidentUrl": "https://ibmgbsindia1prod.service-now.com/incident.do?sys_id=34b05ce01bf78510aed47df4464bcbf8",
                dotValue: 75
            }
        ]
    }
]